// @flow

import * as React from 'react';
import styled from 'styled-components';

import { breakpoint } from '../utils/responsive';
import { grid } from '../utils/layout';
import type { UIProviderContext } from './UIProvider';
import { UIContextPropType } from './UIProvider';
import TopBarContentComponent from './TopBarContent';

import Logo from './Logo';

const TopBar = styled.div`
  background: #ffffff;
  ${breakpoint('small')`
    height: 3.25em;
  `};
  ${breakpoint('medium')`
    height: 5.25em;
  `};
  box-shadow: 0 0 4px 0 rgba(219, 224, 222, 0.4);
`;

const StyledLogo = styled(Logo)`
  height: 1.125em;
  ${breakpoint('medium')`
    height: 1.5em;
  `};
  margin-right: 1.5em;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;

const TopBarContent = styled.div`
  ${grid()};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;

//by having a parent with flex-direction:row, the min-height bug in IE doesn't stick around.
const PageContainerParent = styled.div`
  display: flex;
  flex-direction: row;
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export type PageProps = {
  title: string,
  children: React.Node,
  renderTopbarContent?: () => any,
  renderContentTopbar?: () => any,
};

class EmptyPage extends React.Component<PageProps, *> {
  context: UIProviderContext;
  titlePrefix: string;

  static contextTypes = {
    dbui: UIContextPropType,
  };

  static TopBar = TopBar;

  updateTitle(props: PageProps) {
    document.title =
      this.context.dbui.appName + (props.title ? ` - ${props.title}` : '');
  }

  componentDidMount() {
    this.updateTitle(this.props);
  }

  UNSAFE_componentWillUpdate(nextProps: PageProps) {
    if (this.props.title !== nextProps.title) {
      this.updateTitle(nextProps);
    }
  }

  render() {
    return (
      <TopBarContentComponent>
        {({ renderTopBarContent }) => (
          <PageContainerParent>
            <PageContainer>
              <TopBar>
                <TopBarContent>
                  <StyledLogo onClick={this.context.dbui.onLogoClick} />
                  {renderTopBarContent && renderTopBarContent()}
                </TopBarContent>
              </TopBar>
              {this.props.children}
            </PageContainer>
          </PageContainerParent>
        )}
      </TopBarContentComponent>
    );
  }
}

export default EmptyPage;
